import { render, staticRenderFns } from "./ServiceproviderCustomerMarket.vue?vue&type=template&id=3cc59013&"
import script from "./ServiceproviderCustomerMarket.vue?vue&type=script&lang=js&"
export * from "./ServiceproviderCustomerMarket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports